import { getMuiAvatar } from './MuiAvatar'
import MuiButton from './MuiButton'
import MuiChip from './MuiChip'
import { getMuiIconButton } from './MuiIconButton'
import MuiPaper from './MuiPaper'
import MuiTypography from './MuiTypography'

export const getOverrides = palette => {
  const MuiAvatar = getMuiAvatar(palette)
  const MuiIconButton = getMuiIconButton(palette)

  return {
    MuiAvatar,
    MuiButton,
    MuiChip,
    MuiIconButton,
    MuiPaper,
    MuiTypography,
  }
}
